import { SELECIONAR_AGENDAMENTO_VIAGEM } from '../types'

export default function selecionarAgendamentoViagem (agendamentoViagem) {
  return {
    type: SELECIONAR_AGENDAMENTO_VIAGEM,
    payload: agendamentoViagem
  }
}
